<template>
  <div>
    <a-space :size="spaceSize">
      <a-space>
        <span>{{$t('business.label.packingPosition')}}:</span>
        <vxe-select v-model="position.no" :options="positions" placeholder="placeholder.packingPosition" @change="(value)=>positionChange(value)"/>
      </a-space>
      <vxe-input v-if="device" v-model="container.no" placeholder="business.label.turnoverBox" @keydown.native.enter="obtain"/>
      <vxe-input v-if="!device" v-model="pickingOrder.no" placeholder="business.label.pickingOrder" @keydown.native.enter="obtain"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>getDetail(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="packingPosition.no" title="business.label.packingPosition"/>
      <vxe-column v-if="device" field="container.no" title="business.label.turnoverBox"/>
      <vxe-column v-if="!device" field="pickingOrder.no" title="business.label.pickingOrder"/>
      <vxe-column field="pickupMode.name" title="business.label.pickupMode"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="customer.no" title="business.label.customerNo"/>
      <vxe-column field="customer.name" title="business.label.customerName"/>
      <vxe-column field="numberOfSku" title="business.label.numberOfItem"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'PackingTaskTable',
  props: {
    device: { type: Boolean, default: false },
    positionTypeId: { type: String, default: '' },
    positions: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      position: { id: null, no: '' },
      container: { id: null, no: '' },
      pickingOrder: { id: null, no: '' },
      data: [],
      contentSize: 0,
      page: 1,
      size: 20,
      spaceSize: 100,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      const args = {
        'positionType.id': this.positionTypeId,
        'position.id': this.position.id
      }
      findAll('packingContainerCommandsFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    obtain() {
      if (this.position.no === '') {
        return this.$message.warning('请先选择打包位')
      }
      if (this.device) {
        if (this.container.no === '') {
          return this.$message.warning('请输入周转箱号')
        }
        this.$emit('dblclick', { position: this.position, container: this.container })
      } else {
        if (this.pickingOrder.no === '') {
          return this.$message.warning('请输入拣货单号')
        }
        this.$emit('dblclick', { position: this.position, pickingOrder: this.pickingOrder })
      }
    },
    getDetail(row) {
      if (this.device) {
        this.$emit('dblclick', { position: row.packingPosition, container: row.container })
      } else {
        this.$emit('dblclick', { position: row.packingPosition, pickingOrder: row.pickingOrder })
      }
    },
    positionChange(value) {
      this.position.id = value
      this.refresh()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    reset() {
      this.position = { id: null, no: '' }
      this.container = { id: null, no: '' }
      this.pickingOrder = { id: null, no: '' }
      this.refresh()
    }
  }
}
</script>